module.exports = __webpack_public_path__ + "img/8229229.svg";